import * as React from 'react'

import { EyeClosedIcon, EyeOpenIcon } from '@radix-ui/react-icons'
import { Slot } from '@radix-ui/react-slot'
import { cva, type VariantProps } from 'class-variance-authority'

import { useControllableState } from '@/components/hooks/use-controllable-state'
import { Button } from '@/components/ui/button'

import { cn } from '@/lib/cn'
import { InputProps } from './input'

const inputVariants = cva(
  'flex h-9 w-full rounded-md border border-input bg-white px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50'
)
const InputPassword = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    const [open, setOpen] = useControllableState({
      defaultProp: false,
    })

    return (
      <div className="relative">
        <input
          type={open ? 'text' : 'password'}
          className={inputVariants({ className: cn('pr-8', className) })}
          ref={ref}
          {...props}
        />
        <Button
          className="absolute right-0 top-0 aspect-[1/1] h-9 p-0 hover:bg-transparent"
          type="button"
          variant={'ghost'}
          onClick={() => setOpen((x) => !x)}
        >
          <Slot className="h-4 w-4">
            {open ? (
              <EyeOpenIcon className="text-primary-2" />
            ) : (
              <EyeClosedIcon className="text-gray-600" />
            )}
          </Slot>
        </Button>
      </div>
    )
  }
)
InputPassword.displayName = 'InputPassword'

export { InputPassword }
